import { AccountSubscription } from '@payaca/types/subscriptionTypes';

export interface SubscriptionState {
  // eslint-disable-next-line typescript-eslint/no-redundant-type-constituents -- AccountSubscription resolves correctly when deps are built
  accountSubscription: AccountSubscription | null;
  isGettingAccountSubscription: boolean;
}

export enum SubscriptionActionTypes {
  REQUEST_GET_ACCOUNT_SUBSCRIPTION = 'subscription.requestGetAccountSubscription',
  GET_ACCOUNT_SUBSCRIPTION_SUCCESS = 'subscription.getAccountSubscriptionSuccess',
  GET_ACCOUNT_SUBSCRIPTION_FAILURE = 'subscription.getAccountSubscriptionFailure',
  CLEAR_ACCOUNT_SUBSCRIPTION = 'subscription.clearAccountSubscription',
}

export interface SubscriptionSagaConfig {
  apiBaseurl: string;
  getAuthHeader: () => Promise<string>;
  isNativeApp?: boolean;
}
